<template>
  <div>
  <p class="alertHonor" v-if="showAlertHonor"></p>
  <p class="alertHonorBox" @click="alertHonorClick"></p>
  <p class="honorClose" @click="honorClose"></p>

  <p class="honorBgLeft">升级通知</p>
  <p class="honorBgRight" @click='handleActions("share")'>分享</p>
  <p class="honorText">{{title}}</p>

  <p class="honorRanking">
    {{ranking}}
      </p>
  </div>
</template>
<script>
  export default{
    props:{
      img:{type:String},  //图片
      title:{type:String},  //达人昵称
      ranking:{type:String},   //排名
      share:{type:Function}, //分享
    },
    data(){
      return{
        showAlertHonor:true
      }
    },
    methods:{
      alertHonorClick(){ //点击其他区域
        this.showAlertHonor = false; //关闭整个窗口
      },
      honorClose(){ //点击关闭图标
        this.showAlertHonor = false;
      },
      handleActions(action){
        this.callback(action);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Test.vue